import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthGuardService } from '@alfresco/adf-core';
import { WkAuthenticationService } from '../services';

export const WkAuthGuardEcm: CanActivateFn = async (
  _: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean> => {
  const authGuardBaseService = inject(AuthGuardService);
  const authenticationService = inject(WkAuthenticationService);

  if (
    authenticationService.isLoggedIn() &&
    authGuardBaseService.isLoginFragmentPresent()
  ) {
    return authGuardBaseService.redirectSSOSuccessURL();
  }

  if (
    authenticationService.isEcmLoggedIn() ||
    authGuardBaseService.withCredentials
  ) {
    return true;
  }

  if (
    !authenticationService.isEcmLoggedIn() &&
    authGuardBaseService.isSilentLogin() &&
    !authenticationService.isPublicUrl()
  ) {
    return authenticationService.ssoImplicitLogin();
  }

  return authGuardBaseService.redirectToUrl(state.url);
};
